module.exports = __webpack_public_path__ + "img/people.e3e382d2.svg";